@if (isVisible()) {
  <div [class]="alertClasses()" [class.opacity-0]="!isVisible()" role="alert">
    <app-icons [icon]="defaultIcon()" svgClass="w-4 h-4 shrink-0 mt-0.5 md:mt-0" aria-hidden="true" />
    <span class="sr-only">{{ variant() }}</span>
    <div class="ms-2 text-sm">
      <ng-content />
    </div>
    @if (closable()) {
      <button
        type="button"
        [class]="buttonClasses()"
        (click)="close()"
        aria-label="Close">
        <span class="sr-only">Close</span>
        <app-icons icon="close" />
      </button>
    }
  </div>
}
